<app-dashboard-pnrr-non-disegnabile [isPublic]="true"></app-dashboard-pnrr-non-disegnabile>